import React from 'react';
import { Link } from 'react-router-dom';

const ThankYouPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white p-8 rounded-lg shadow-md text-center">
          {/* Success Icon */}
          <div className="mb-6">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>

          {/* Thank You Message */}
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Спасибо за прохождение теста!
          </h1>
          
          <p className="text-lg text-gray-600 mb-6">
            Ваши результаты были успешно обработаны и отправлены на анализ.
          </p>

          {/* What happens next */}
          <div className="bg-blue-50 p-6 rounded-lg mb-8">
            <h2 className="text-xl font-semibold text-blue-800 mb-4">
              Что происходит дальше?
            </h2>
            <div className="text-left space-y-3">
              <div className="flex items-start">
                {/* <div className="flex-shrink-0 w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-0.5">
                  1
                </div> */}
                {/* <p className="text-blue-700">
                  <strong>Автоматическая обработка:</strong> Ваши ответы автоматически заносятся в Excel таблицу с результатами
                </p> */}
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-0.5">
                  1
                </div>
                <p className="text-blue-700">
                  <strong>Отправка результатов:</strong> Детальный анализ отправляется на почту специалисту
                </p>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-0.5">
                  2
                </div>
                <p className="text-blue-700">
                  <strong>Обратная связь:</strong> С вами свяжутся для обсуждения результатов и рекомендаций
                </p>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="bg-gray-50 p-6 rounded-lg mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Свяжитесь с нами
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold text-gray-700 mb-2">Контактная информация:</h3>
                <div className="space-y-2 text-gray-600">
                {/* <div className="space-y-2 text-yellow-700"> */}
                <p>
                  <strong>Телефон:</strong> 
                  <a 
                    href="tel:+79923006546" 
                    className="text-blue-600 hover:text-blue-800 underline ml-1"
                  >
                    +7(992)300-65-46
                  </a>
                </p>
                <p>
                  <strong>Email:</strong> 
                  <a 
                    href="mailto:developskillsnow@yandex.ru" 
                    className="text-blue-600 hover:text-blue-800 underline ml-1"
                  >
                    developskillsnow@yandex.ru
                  </a>
                </p>
                <p>
                  <strong>Сайт:</strong> 
                  <a 
                    href="https://форматы.рус" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline ml-1"
                  >
                    https://форматы.рус
                  </a>
                </p>
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-gray-700 mb-2">Время работы:</h3>
                <div className="space-y-1 text-gray-600">
                  <p>Пн-Пт: 8:00 - 20:00</p>
                  <p>Сб-Вс: по записи</p>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Information */}
          <div className="bg-yellow-50 p-6 rounded-lg mb-8">
            <h2 className="text-xl font-semibold text-yellow-800 mb-4">
              Дополнительная информация
            </h2>
            <div className="text-left space-y-3 text-yellow-700">
              <p>
                <strong>Время обработки:</strong> Результаты обычно обрабатываются в течение 1-2 рабочих дней
              </p>
              <p>
                <strong>Конфиденциальность:</strong> Все ваши данные защищены и используются только для анализа результатов теста
              </p>
              <p>
                <strong>Дополнительные тесты:</strong> Вы можете пройти другие психологические тесты для более полного анализа
              </p>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/tests"
              className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              Пройти другие тесты
            </Link>
            <Link
              to="/"
              className="px-6 py-3 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
            >
              Вернуться на главную
            </Link>
          </div>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              Спасибо за доверие! Мы ценим ваше время и готовы помочь в развитии вашего потенциала.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
